import Constansts from "../components.constants.js";
import Utils from "../components.utils.js";
import axios from "axios";

const CancelToken = axios.CancelToken;
axios.defaults.baseURL = window.location.origin;
var fileUploadXHR = {};
class DispatcherEvent {
    constructor(eventName) {
        this.eventName = eventName;
        this.callbacks = [];
    }

    registerCallback(callback) {
        this.callbacks.push(callback);
    }

    unregisterCallback(callback) {
        const index = this.callbacks.indexOf(callback);
        if (index > -1) {
            this.callbacks.splice(index, 1);
        }
    }

    fire(data) {
        const callbacks = this.callbacks.slice(0);
        callbacks.forEach((callback) => {
            callback(data);
        });
    }
}

class FileUploader {
    constructor(file, dstDir, uploadToken, sessionId, fileUID, jobId, uploadDirURL, createdTime, finalisedFileName, start = true, offset = 0, groupId = null, isFolderUpload = false) {
        this.file = file;
        this.dstPath = dstDir;
        this.uploadDirURL = uploadDirURL;
        this.fileName = finalisedFileName;
        this.path = dstDir + "/" + finalisedFileName;
        this.fileSize = this.file.size;
        this.fileUID = fileUID;
        this.jobId = jobId;
        this.groupId = groupId;
        this.isFolderUpload = isFolderUpload;
        this.uploadToken = uploadToken;
        this.createdTime = createdTime;
        this.sessionId = sessionId;
        this.chunkSize = Utils.getMaxChunkSize();
        if (this.chunkSize > this.fileSize) {
            this.chunkSize = Math.round(this.fileSize / 2);
        }
        this.filePos = offset;
        this.uploadPercentage = 0;
        this.bandwidth = 0;
        this.totalUploaded = 0;
        this.status = "INITIALIZING";
        this.events = {};
        this.startTime = null;
        this.isproxyBinUpload = false;
        this.sourceFileId = null;
        this.proxy_info = {"thumbnail_uri":""};
        this.finalSingleFileUploadCompletedPromise = null;
        this.isChatUpload = false;
        this.isUploadPaused = false;
        this.isUploadInProgress = false;
        this.sessionUploadedBytes = 0;
        this.sessionStartTime = null;
        if (start) {
            this.start();
        }
    }

    doUploadOnProxyBin(){ // {@params isproxyBinUpload : Boolean} is upload required on proxy bin
         this.isproxyBinUpload = true;
    }

    setFilename(filename){
        this.fileName = filename;
    }

    setSourceFileId(sourfile_id){   // source_file id is _id of source file
        this.sourceFileId = sourfile_id
    }

    setForProxy(isForProxyBinUpload){ // {isForProxyBinUpload : Boolean} if upload is required on proxy bin
        this.isproxyBinUpload = isForProxyBinUpload;
    }

    setPath(){
        this.path = this.dstPath + "/" + this.fileName;
    }

    getDestinationUri(){
        return this.path;
    }

    doChatUpload(){
        this.isChatUpload = true;
    }

    humanizeBandwidth(bytes) {
        if (!bytes || bytes == 0) {
            return { bandwidth: 0, unit: "KB/s" };
        }
        if (bytes < 0) {
            return { bandwidth: 0, unit: "KB/s" };
        }
        if (bytes < 1024) return { bandwidth: bytes.toFixed(2), unit: " B/s" };
        else if (bytes < 1048576)
            return { bandwidth: (bytes / 1024).toFixed(2), unit: "KB/s" };
        else if (bytes < 1073741824)
            return { bandwidth: (bytes / 1048576).toFixed(2), unit: "MB/s" };
        else if (bytes < 1099511627776)
            return { bandwidth: (bytes / 1073741824).toFixed(2), unit: "GB/s" };
        else return { bandwidth: (bytes / 1099511627776).toFixed(2), unit: "TB/s" };
    }
    getBandwidth() {
        if (!this.sessionStartTime) {
            return this.humanizeBandwidth(0);
        }
        const elapsedSeconds = (performance.now() - this.sessionStartTime) / 1000;
        if (elapsedSeconds <= 0) {
            return this.humanizeBandwidth(0);
        }
        return this.humanizeBandwidth(
            this.sessionUploadedBytes / elapsedSeconds
        );
    }
    onUploadStart() {
        if (!this.sessionStartTime) {
            this.sessionStartTime = performance.now();
        }
    }
    onChunkUploaded(bytes) {
        this.sessionUploadedBytes += bytes;
    }

    getProgressInfo() {
        this.bandwidth = this.getBandwidth();
        return {
            bandwidth: this.bandwidth,
            uploadedPercentage: this.uploadPercentage,
            fileUID: this.fileUID,
            status: this.status,
            uploaded: this.totalUploaded,
            fileInfo: this.file,
            jobId: this.jobId
        };
    }

    async abortPost(payload) {
        // source.cancel();
        try {
            await axios.delete(`${Constansts.uploadUrl}/${payload.job_id}/file/${payload.file_uid}`, payload);
            const cancel = fileUploadXHR[payload.file_uid];
            if (cancel) {
                cancel("Upload aborted by user");
                delete fileUploadXHR[payload.file_uid];
            }
            this.status = "FAILED";
            this.dispatch("exit", this.getProgressInfo());
            console.log("fileUploadXHR",fileUploadXHR)
        } catch (error) {
            if (error.response) {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
            return {}
        }
    }

    async resumableUpload(filePos, chunkSize = -1) {
        if(this.isUploadInProgress) return;
        if (chunkSize <= 0) {
            try{
              if(this.finalSingleFileUploadCompletedPromise){
                this.finalSingleFileUploadCompletedPromise.then(() => {
                    this.dispatch("fileUploadDone",this.getProgressInfo());
                });
              }
            }catch(e){console.log(e)}
            return;
        }
        // console.log('this.file:',this.file,'filePos:',filePos,'filePos + chunkSize:',filePos + chunkSize);
        let blob = this.file.slice(filePos, filePos + chunkSize);
        const endByte = Math.min(filePos + chunkSize - 1, this.fileSize - 1);

        let uploadHeaders = {
            // "Content-Length": chunkSize,
            "Content-Type": "application/octet-stream;charset=UTF-8",
            "Content-Disposition": `attachment; filename = "${encodeURIComponent(this.fileName)}"`,
            "X-Content-range": `bytes ${filePos}-${endByte}/${this.fileSize}`,
            "Session-Id": this.sessionId,
            "File-Uid": this.fileUID,
            "File-Name": encodeURIComponent(this.fileName),
            "Slug-Name": encodeURIComponent(this.file.name),
            "Dst-Dir": encodeURIComponent(this.dstPath),
            "File-Size": this.fileSize,
            "First-Chunk": filePos == 0 ? true : false,
            "Last-Chunk": filePos + chunkSize >= this.fileSize ? true : false,
            "Last-Modified": this.file.lastModified,
            "Uploaded-Bytes": filePos + chunkSize,
            "Src-Path": `${encodeURIComponent(this.dstPath)}/${this.sessionId}`,
            "Token-Id": this.uploadToken,
            "Job-Id": this.jobId,
            "For-Proxy": this.isproxyBinUpload,
            "Relative-Path": this.isFolderUpload ? encodeURIComponent(this.file.webkitRelativePath) : undefined,
        }
        if(this.isproxyBinUpload) uploadHeaders['Source-File-Uid'] = this.sourceFileId;
        
        if(this.isChatUpload) uploadHeaders['Update-Thumbnail'] = true;
        this.isUploadInProgress = true;
        this.status = "INPROGRESS";
        axios
            .post(/*'/resumable'+*/encodeURIComponent(`${Constansts.nginxUploadUrl + this.uploadDirURL}`), blob, {
                headers: uploadHeaders,
                cancelToken: new CancelToken(c=> {
                    fileUploadXHR[this.fileUID] = c;
                }),
                onUploadProgress: (e) => {
                    const uploaded = filePos + e.loaded;

                    this.uploadPercentage = Math.min(
                        Math.round((uploaded / this.fileSize) * 100),
                        100
                    );

                    this.totalUploaded = uploaded;
                    this.dispatch("progress", this.getProgressInfo());
                },
            })
            .then(() => {
                const uploadedBytes = Math.min(chunkSize, this.fileSize - filePos);
                this.onChunkUploaded(uploadedBytes);
                this.totalUploaded = filePos + uploadedBytes;
                this.isUploadInProgress = false;
                if(!this.isUploadPaused){
                    this.filePos = this.filePos + chunkSize;
                    if (this.filePos + chunkSize >= this.fileSize) {
                        this.finalSingleFileUploadCompletedPromise = this.resumableUpload(this.filePos, this.fileSize - this.filePos);
                        this.status = "COMPLETED";
                        this.dispatch("complete", this.getProgressInfo());
                        this.dispatch("exit", this.getProgressInfo());
                    } else {
                        this.resumableUpload(this.filePos, chunkSize);
                    }
                }

            })
            .catch((error) => {
                if (axios.isCancel?.(error) || error?.code === "ERR_CANCELED" || this.isUploadPaused) {
                    this.isUploadInProgress = false;
                    return;
                }
                this.status = "FAILED";
                this.uploadPercentage = -1;
                console.error(`Failed to upload file->${this.fileName}, error->${error}`);
                this.dispatch("exit", this.getProgressInfo());
            });
    }

    start() {
        console.log(`[upload][Uploading to ${this.path}, DstDir ${this.dstPath}, UploadURL ${this.uploadDirURL}]`)
        this.onUploadStart();
        this.isUploadPaused = false;
        if(!this.isUploadInProgress){
            this.resumableUpload(this.filePos, this.chunkSize);
        }
    }
    pause() {
        this.isUploadPaused = true;
        const cancel = fileUploadXHR[this.fileUID];
        if (cancel) {
            cancel("Upload paused by user");
            delete fileUploadXHR[this.fileUID];
        }
    }

    resume(){
        this.isUploadPaused = false;
        this.onUploadStart();
        if(!this.isUploadInProgress && this.status == "INPROGRESS"){
            this.resumableUpload(this.filePos, this.chunkSize);
        }
    }

    dispatch(eventName, data) {
        const event = this.events[eventName];
        if (event) {
            event.fire(data);
        }
    }

    on(eventName, callback) {
        let event = this.events[eventName];
        if (!event) {
            event = new DispatcherEvent(eventName);
            this.events[eventName] = event;
        }
        event.registerCallback(callback);
    }

    off(eventName, callback) {
        const event = this.events[eventName];
        if (event && event.callbacks.indexOf(callback) > -1) {
            event.unregisterCallback(callback);
            if (event.callbacks.length === 0) {
                delete this.events[eventName];
            }
        }
    }
}

export default FileUploader;